import { Box } from '@chakra-ui/react';
import { ErrorMessage } from 'formik';
import styled from '@emotion/styled';

const ErrorMessageText = styled.div`
  font-size: 12px;
  color: red;
  margin-right: 2px;
`;

const FormErrorMessage = ({ name }) => (
  <Box minH="20px">
    <ErrorMessage
      name={name}
      render={(msg) => {
        if (typeof msg === 'string') {
          return <ErrorMessageText>{msg}</ErrorMessageText>;
        }
        return null;
      }}
    />
  </Box>
);

export default FormErrorMessage;
